import { ref, type CSSProperties } from 'vue'

const isLoading = ref<boolean>(false)
const style = ref<CSSProperties>({})
const clazz = ref<string>('')

export const useFullscreenLoader = () => {
  const setLoading = (loading: boolean) => {
    isLoading.value = loading
  }

  const setStyle = (css: CSSProperties) => {
    style.value = css
  }

  const setClass = (classStr: string) => {
    clazz.value = classStr
  }

  return { loading: isLoading, style, setLoading, setStyle, setClass, class: clazz }
}
